import {useContext, useState} from "react";
import EventContext from '/context/EventContext.js';
import Image from "next/image";
import VideoJS from "/components/shared/VideoJS";
import {PlayIconImg} from "/components/shared/SvgIcons";

export default function GallerieView({id, classIdentifier}) {
    const {event} = useContext(EventContext);
    const [selectedImage, setSelectedImage] = useState(event?.picture);
    const [selectedTrailer, setSelectedTrailer] = useState(event?.trailer);

    const handleImageClick = (img) => {
        setSelectedImage(img);
        setSelectedTrailer("")
    }

    return (
        <section className={classIdentifier} id={id}>
            <div>
                <div className="flex flex-wrap md:flex-nowrap">
                    {event.age_restriction ? (
                        <span
                            className="bg-gray-light mr-2 text-gray-dark uppercase text-sm p-1 mb-2 rounded">
                      ab {event.age_restriction} Jahren
                    </span>
                    ) : null}
                    {event.custom_data?.duration_description ? (
                        <span
                            className="bg-gray-light text-gray-dark uppercase text-sm p-1 mb-2 rounded">
                      {event.custom_data?.duration_description}
                    </span>
                    ) : null}
                </div>
                {event.custom_data?.author_description ? (
                    <p className='mt-4 mb-8 text-gray-dark xl:text-base text-sm font-light w-fit'>
                        {event.custom_data?.author_description?.split('\n').map((item, key) => {
                            return <span key={key}>{item}<br/></span>
                        })}
                    </p>
                ) : null}

                <div className='mt-8 relative'>
                    {
                        selectedTrailer ?
                            event?.trailer ? <VideoJS className="vjs-big-play-centered" video={selectedTrailer || {}} controls /> :
                                <div
                                    className="absolute top-0 left-0 h-full w-full bg-gray-light flex items-center justify-center text-center">
                                    <img src={event.picture} className='h-full w-auto'/>
                                </div> :
                            selectedImage ? (
                                <div
                                    className="absolute top-0 left-0 h-full w-full bg-gray-light flex items-center justify-center text-center">
                                    <img src={selectedImage} className='h-full w-auto'/>
                                </div>
                            ) : ''

                    }
                </div>

                <div className="flex mt-2 flex-wrap justify-start">
                    {
                        event.trailer ?
                            <div className='relative w-28 h-20 mr-2 cursor-pointer'
                                 onClick={() => setSelectedTrailer(event?.trailer)}>
                                <Image src={event.picture} width="114px"
                                       height="76px"/>
                                <button className="vjs-big-play-button-img" type="button" title="Play Video">
                                    <span className="flex justify-center items-center">{PlayIconImg()}</span></button>
                            </div>
                            :
                            <div className='w-28 h-20 mr-2 cursor-pointer'
                                 onClick={() => setSelectedImage(event.picture)}>
                                <Image src={event.picture} width="114px" height="76px"/>
                            </div>

                    }
                    {((event || {}).images || []).map(image => (
                        <div className="mr-2 cursor-pointer " onClick={() => handleImageClick(image.url)}>
                            <img src={image.url} className="w-auto h-[76px]"/>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
}
